import React, { useEffect, useState } from "react";
import { getContractsByID } from "../../api/user";
import { getPackageInfo } from "../../api/logistic";
import { useLanguage } from "../../context/localeContext";
import { useTranslation } from "react-i18next";
import { useMessenger } from "../../context/messengerContext";

import Btn from "../../components/Btn/Btn";
import BasicDropdown from "../../components/inputs/basicDropdown/basicDropdown";
import BasicInput from "../../components/inputs/basicInput/basicInput";
import BasicPanel from "../../components/panels/basicPanel/basicPanel";

import StepsHeader from "./utils/stepsHeader";
import TrackItem from "./trackItem";

import "./packageTracking.css";
import { Loader } from "rsuite";

const TrackPackage = () => {
  const { userId, platform } = useMessenger();
    const { t } = useTranslation('basic');

    const [contracts, setContracts] = useState([]); // Контракты пользователя
  const [selectedContract, setSelectedContract] = useState(""); // Выбранный контракт
  const [trackNumber, setTrackNumber] = useState(""); // Введённый трек-номер
  const [packageInfo, setPackageInfo] = useState(null); // Информация о посылке
  const [error, setError] = useState(null); // Ошибки загрузки/обработки
  const [wasSearched, setWasSearched] = useState(false);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
      if (!userId) return;
      getContractsByID({ platform, userId }).then((res) => {
          if (res) {
              setContracts(res.map((contract_number) => ({label: contract_number, value: contract_number})));
          }
      });
  }, [platform, userId])

  useEffect(() => {
    if (!contracts.length) return;
    if (contracts.length === 1) {
      setSelectedContract(contracts[0].value);
    }
  }, [contracts]);

  // Обработчик поиска посылки
  const handleSearch = async () => {
    let e = {};

    if (!selectedContract) {
      e.contract_number = t("select_contract_number");
    }

    if (!trackNumber) {
      e.track_number = t("enter_track_number");
    }

    if (Object.keys(e).length) {
      setError(e);
      return;
    }

    try {
      setLoading(true);

      const data = await getPackageInfo({
        contract_number: selectedContract,
        package_number: trackNumber
      });
      setWasSearched(true);
      if (data?.detail) {
        setPackageInfo(null);
        return;
      }
      setPackageInfo({...data, track_number: data.number});

    } catch (error) {
      console.error("Ошибка получения данных по трек-номеру:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <StepsHeader />
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        paddingTop: "1.5rem",
        paddingInline: "1rem"
      }}>
        <BasicPanel className={"trackingPanel"}>
            <div className="trackingPanelWrapper">
            <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
              <BasicDropdown
                label={t("contract_number")}
                placeholder={t("select_contract_number")}
                error={error?.contract_number}
                data={contracts}
                onChange={(c) => setSelectedContract(c)}
                value={selectedContract}
              />
              {error?.contract_number && (
                <div className="field-error paragraph-14R">{t("invalid_contract")}</div>
              )}
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
              <BasicInput
                placeholder={t("track_number_input")}
                error={error?.track_number}
                onChange={(val) => setTrackNumber(val)}
                value={trackNumber}
              />
              {error?.track_number && (
                <div className="field-error paragraph-14R">{t("invalid_track_number")}</div>
              )}
            </div>

              <Btn text={t("find_button")} fluid onClick={handleSearch}/>
            </div>
        </BasicPanel>
        { 
          loading ?
          <Loader size="lg" /> :
          (packageInfo ?
          <TrackItem track_data={{...packageInfo, contract_number: selectedContract, }} /> :
          wasSearched && <p className="paragraph-14R">{t("package_not_found")}</p>
          )
        }
      </div>
    </>
  );
};

export default TrackPackage;
